import React, { useEffect } from 'react';
import { User } from './ifmsTypes';
import ApplicationLoading from './ApplicationLoading';

import {NavigationType, openNewPage} from '././util/navigationHelpers';
import { useHistory } from 'react-router';

type Props = {
  autoLoginCall: () => void,
};

const AutoLogin: React.FC<Props> = ({ autoLoginCall }) => {
  
  useEffect(() => {
    autoLoginCall()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (<ApplicationLoading />);

}

export default AutoLogin;



